import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const AcessoNegado = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/home');
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Paper elevation={3} sx={{ margin: 2, padding: 4, textAlign: 'center', maxWidth: 400 }}>
        <LockOutlinedIcon sx={{ fontSize: 48, color: '#d32f2f', marginBottom: 2 }} />
        <Typography variant="h5" component="h1" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ marginBottom: 3 }}>
          Você não tem permissão para acessar esta página.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackToHome}
        >
          Entendi! Voltar para a Home
        </Button>
      </Paper>
    </Box>
  );
};

export default AcessoNegado;